import { Folder } from '@/types'

/**
 * Recursively find a folder by ID in a folder tree
 */
export function findFolderById(folders: Folder[], targetId: number): Folder | null {
  for (const folder of folders) {
    if (folder.id === targetId) {
      return folder
    }

    // Search in subfolders
    if (folder.subfolders && folder.subfolders.length > 0) {
      const found = findFolderById(folder.subfolders, targetId)
      if (found) return found
    }

    // Search in children (alternative naming)
    if (folder.children && folder.children.length > 0) {
      const found = findFolderById(folder.children, targetId)
      if (found) return found
    }
  }

  return null
}

/**
 * Get the parent folder of a given folder using the folder tree
 */
export function getParentFolder(folders: Folder[], currentFolder: Folder): Folder | null {
  if (!currentFolder.parent_id) {
    return null // This is a root folder
  }

  return findFolderById(folders, currentFolder.parent_id)
}
